import { service, BASE_API } from "@/utils/request";
export default {
  // 获取视频点播广告列表
  getVideoDemandAdList(params) {
    return service({
      url: "/cloud/activity/ad/video/list",
      method: "get",
      params
    });
  },
  // 视频点播广告详情
  getVideoDemandAdDetail(id) {
    return service({
      url: `/cloud/activity/ad/video/detail/${id}`,
      method: "get"
    });
  },
  // 更新视频点播广告
  updateVideoDemandAd(data) {
    return service({
      url: `/cloud/activity/ad/video/update`,
      method: "post",
      data
    });
  },
  // 删除视频点播广告
  deleteVideoDemandAd(id) {
    return service({
      url: `/cloud/activity/ad/video/delete/${id}`,
      method: "post"
    });
  },
  // 添加视频点播广告
  addVideoDemandAd(data) {
    return service({
      url: `/cloud/activity/ad/video/add`,
      method: "post",
      data
    });
  },
  // 获取点播广告用户列表
  getAdUserList(params) {
    return service({
      url: "/cloud/activity/ad/video/visit/list",
      method: "get",
      params
    });
  },
  // 导出点播广告用户列表
  exportAdUserList(adId) {
    return service({
      url: "/cloud/activity/ad/video/visit/list/export",
      method: "get",
      params: { adId },
      responseType: 'blob'
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/operateManage/videoDemandAd.js